import React from 'react'
import classNames from 'classnames'
import CardColumns from './CardColumns'
import { CardsProps } from './Cards.d'

const Cards = ({
  iconStyle,
  bgColor,
  cssClasses,
  itemsHeadingCss,
  columns,
  scrollTrackingSectionName,
  uniqueId
}: CardsProps) => {
  const sectionClasses = classNames('overflow-hidden', bgColor, cssClasses, {
    '[@media(max-width:991px)]:mt-[1.875rem] [@media(min-width:992px)]:mt-[3.75rem]':
      !cssClasses
  })

  const renderColumns = () => {
    return (
      <CardColumns
        cards={columns}
        iconStyle={iconStyle}
        itemsHeadingCss={itemsHeadingCss}
        layout='threeColumnCards'
        mobileSlider={true}
        sliderPagination={true}
      />
    )
  }
  return (
    <div
      className={sectionClasses}
      data-testid='Cards'
      data-tracking-section={scrollTrackingSectionName}
      id={uniqueId}
    >
      <div className='ds-wrapper'>
        <div className='[@media(max-width:991px)]:ds-grid [@media(min-width:992px)]:flex justify-center [@media(max-width:991px)]:!px-0'>
          {renderColumns()}
        </div>
      </div>
    </div>
  )
}

export default Cards
